import React from 'react';
import PropTypes from 'prop-types';
import { Card, Typography, Form, Grid } from 'components/base';

const SelectPanel = props => {
  const handleOnChange = e => {
    props.onChange(e.target.value);
  };

  return (
    <Card className="mx-auto mb-2 mb-sm-5 mw-660">
      <Card.Body>
        <Grid.Row>
          <Grid.Col xs={12} md={8}>
            <Typography.H6>{props.title}</Typography.H6>
            <Typography.P className="mt-0 mb-1 mb-md-0 small">{props.description}</Typography.P>
          </Grid.Col>
          <Grid.Col xs={12} md={4}>
            <Form.Select value={props.active} onChange={handleOnChange}>
              {props.items.map(item => (
                <Form.SelectOption key={item.id} value={item.id}>
                  {item.label}
                  {item.description && ` (${item.description})`}
                </Form.SelectOption>
              ))}
            </Form.Select>
          </Grid.Col>
        </Grid.Row>
      </Card.Body>
    </Card>
  );
};

SelectPanel.propTypes = {
  active: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  items: PropTypes.array,
  onChange: PropTypes.func,
};

export default SelectPanel;
